export default class Form {
  constructor() {
    this.inputs = document.querySelectorAll('[data-form="input"]');
    this.labels = document.querySelector('[data-form="label"]');

    this.showLabel = this.showLabel.bind(this);
    this.hideLabel = this.hideLabel.bind(this);

    this.init();
  }

  init() {
    if (!this.inputs || !this.labels) return;
    this.bindEvents();
  }

  bindEvents() {
    this.inputs.forEach(input => input.addEventListener('focus', this.showLabel));
    this.inputs.forEach(input => input.addEventListener('keyup', this.showLabel));
    this.inputs.forEach(input => input.addEventListener('blur', this.hideLabel));
  }

  showLabel(e) {
    e.currentTarget.nextElementSibling.classList.add('is-active');
  }

  hideLabel(e) {
    let isFilled = e.currentTarget.value.length > 0;
    if (isFilled) return;
    e.currentTarget.nextElementSibling.classList.remove('is-active');
  }
}
